import { createSlice } from '@reduxjs/toolkit';

export const pagesSlice = createSlice({
  name: 'pages',
  initialState: {
    list: [],
    activeId: 0,
    homePageId: 0,
    title: '',
    homeTitle: '',
  },
  reducers: {
    pagesStore: (state, { payload }) => {
      state.homePageId = payload.homePageId;
      state.activeId = payload.homePageId;
      state.title = payload.list?.find((item) => item.id === payload.homePageId)?.title;
      state.list = payload.list;
    },
    pagesUpdateList: (state, action) => {
      state.list = action.payload;
    },
    pagesUpdateActiveId: (state, action) => {
      state.activeId = action.payload;
    },
    pagesUpdateTitle: (state, action) => {
      state.title = action.payload;
    },
    pagesUpdateHomeTitle: (state, action) => {
      state.homeTitle = action.payload;
    },
  },
});

export const { pagesStore, pagesUpdateList, pagesUpdateActiveId, pagesUpdateHomeTitle, pagesUpdateTitle } = pagesSlice.actions;

export const selectPagesList = (state) => state.pages.list;
export const selectPagesActiveId = (state) => state.pages.activeId;
export const selectPagesTitle = (state) => state.pages.title;
export const selectPagesHomeTitle = (state) => state.pages.homeTitle;
export const selectPagesHomePageId = (state) => state.pages.homePageId;

export default pagesSlice.reducer;
